import React from 'react';
interface RadioListOneColumnProps {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  name: string;
}
export function RadioListOneColumn({
  options,
  value,
  onChange,
  name
}: RadioListOneColumnProps) {
  return <div className="flex flex-col gap-2" data-id="element-225">
      {options.map(option => {
      const isSelected = value === option;
      return <label key={option} className={`
              relative flex items-center px-4 py-3 rounded-lg border cursor-pointer transition-all
              ${isSelected ? 'border-violet-600 bg-violet-50 ring-1 ring-violet-600' : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'}
            `} data-id="element-226">
            <input type="radio" name={name} value={option} checked={isSelected} onChange={() => onChange(option)} className="sr-only" data-id="element-227" />
            <div className={`w-4 h-4 rounded-full border flex items-center justify-center mr-3 ${isSelected ? 'border-violet-600' : 'border-gray-300'}`} data-id="element-228">
              {isSelected && <div className="w-2 h-2 rounded-full bg-violet-600" data-id="element-229" />}
            </div>
            <span className={`text-sm font-medium ${isSelected ? 'text-violet-900' : 'text-gray-700'}`} data-id="element-230">
              {option}
            </span>
          </label>;
    })}
    </div>;
}